import { FormField } from '../types/ContactForm';

export const getEffectiveMaxTotalFileSize = (field: FormField): number | null => {
    if (!field.allowMultipleFiles) {
        return null;
    }

    const perFile = field.maxFileSize || 5;
    const maxFiles = field.maxFiles || 5;

    if (field.maxTotalFileSize !== undefined && field.maxTotalFileSize > 0) {
        return field.maxTotalFileSize;
    }

    return maxFiles * perFile;
};

export const getTotalFileSizeBytes = (fileList: File[]): number =>
    fileList.reduce((sum, file) => sum + file.size, 0);

export const exceedsTotalFileSizeLimit = (field: FormField, fileList: File[]): boolean => {
    const maxTotal = getEffectiveMaxTotalFileSize(field);
    if (maxTotal === null || fileList.length === 0) {
        return false;
    }

    return getTotalFileSizeBytes(fileList) > maxTotal * 1024 * 1024;
};

export const hasPerFileSizeError = (field: FormField, fileList: File[]): boolean => {
    const maxFileSize = (field.maxFileSize || 5) * 1024 * 1024;
    return fileList.some((file) => file.size > maxFileSize);
};

export const hasFileFieldSizeError = (field: FormField, fileList: File[]): boolean =>
    hasPerFileSizeError(field, fileList) || exceedsTotalFileSizeLimit(field, fileList);
